import React from "react";
import careerImg from "../../../assets/Images/r-d/rd_1.jpg";

const Research_Development_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
      <img
        src={careerImg}
        alt="Research & Development"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Research & Development
        </h1>

        {/* Description */}
        <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-3xl leading-relaxed">
          Driving innovation through advanced research, creative problem-solving, 
          and cutting-edge development solutions for future-ready technologies.
        </p>

      </div>
    </section>
  );
};

export default Research_Development_Banner;